import { IPerson } from '../../../models/GroupAccessOwners/PersonVm';
import IGroupAccessOwner from '../../../models/IGroupAccessOwner';

export function DoesPersonHaveGroupAccess(person: IPerson): person is IGroupAccessOwner {
	return (person as IGroupAccessOwner).hasGroupAccess;
}
